import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatStepperModule } from '@angular/material/stepper';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { GalaxyProgressBarModule } from '@vendasta/galaxy/progress-bar';
import { VaCardsModule } from '@vendasta/uikit';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { AssignedSalespersonModule } from '../assigned-salesperson/assigned-salesperson.module';
import { PageComponent } from '../common/page.component';
import { PricePipe } from '../common/pipes/price.pipe';
import { SafeUrlPipe } from '../common/pipes/safe-url.pipe';
import { WEBLATE_COMPONENT_NAME } from '../constants';
import { UpgradeAllSubscriptionModalService } from '../upgrade-subscription-tier/upgrade-all-subscription-modal/upgrade-all-subscription-modal.service';
import { SubscriptionCardComponent } from './manage/card/subscription-card.component';
import { ManageSubscriptionsComponent } from './manage/manage-subscriptions.component';
import { SubscriptionTierRoutingModule } from './subscription-tier-routing.module';
import { ManageSubscriptionsService } from './utils/manage-subscriptions.service';
import { SubscriptionTierUtilsModule } from './utils/subscription-tier-utils.module';

@NgModule({
  declarations: [ManageSubscriptionsComponent, SubscriptionCardComponent],
  imports: [
    CommonModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    SubscriptionTierRoutingModule,
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    VaCardsModule,
    MatIconModule,
    AssignedSalespersonModule,
    GalaxyPipesModule,
    SubscriptionTierUtilsModule,
    GalaxyPageModule,
    MatStepperModule,
    GalaxyInputModule,
    GalaxyFormFieldModule,
    MatInputModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    PageComponent,
    SafeUrlPipe,
    PricePipe,
    GalaxyProgressBarModule,
  ],
  providers: [ManageSubscriptionsService, UpgradeAllSubscriptionModalService],
})
export class SubscriptionTierModule {}
